import { Injectable } from '@angular/core';
import { AuthResponse } from '../models/auth.models';
import { UserDto } from '../models/user.models';

const ACCESS_TOKEN_KEY = 'identity_access_token';
const REFRESH_TOKEN_KEY = 'identity_refresh_token';
const EXPIRES_AT_KEY = 'identity_expires_at';
const USER_KEY = 'identity_current_user';

/**
 * Encapsula la persistencia de la sesión en localStorage. Ningún otro
 * componente/servicio debe tocar localStorage directamente: todos pasan
 * por aquí para poder cambiar la estrategia de almacenamiento a futuro
 * sin tocar el resto de la app.
 */
@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  setSession(response: AuthResponse): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, response.accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, response.refreshToken);
    localStorage.setItem(EXPIRES_AT_KEY, response.expiresAt);
    localStorage.setItem(USER_KEY, JSON.stringify(response.user));
  }

  updateAccessToken(response: Pick<AuthResponse, 'accessToken' | 'refreshToken' | 'expiresAt'>): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, response.accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, response.refreshToken);
    localStorage.setItem(EXPIRES_AT_KEY, response.expiresAt);
  }

  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  getExpiresAt(): Date | null {
    const raw = localStorage.getItem(EXPIRES_AT_KEY);
    return raw ? new Date(raw) : null;
  }

  getUser(): UserDto | null {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as UserDto;
    } catch {
      return null;
    }
  }

  clear(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(EXPIRES_AT_KEY);
    localStorage.removeItem(USER_KEY);
  }
}
